"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _types = _interopRequireDefault(require("../metadata/types"));

var _error = require("../../error");

function optionBuilder(key, context) {
  var optionValue;
  return {
    setValue: function setValue(value) {
      if (optionValue) throw new _error.CompilationError('Options may only have a single value');
      optionValue = value;
    },
    addArgument: function addArgument(value) {
      this.setValue(value);
    },
    addVariable: function addVariable(key) {
      this.addArgument(function () {
        return context.environment.get(key);
      });
    },
    getMetadata: function getMetadata() {
      return _defineProperty({}, _types.default.OPTION, {
        key: key,
        value: optionValue
      });
    },
    build: function build() {
      return [key, optionValue];
    }
  };
}

var _default = optionBuilder;
exports.default = _default;